import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { MultiCurrencyAmount } from '@mews-distributor/common';
import { LocalizedPropertyObject } from '@mews/framework/localization';
import { localizeProperty } from '../../../modules/globalization/selectors';
import { ApplicationState } from '../../../types';

export const getGenericPurchaseEventData = (
    state: ApplicationState,
    {
        amount,
        chainName,
        cityName,
        currencyCode,
        enterpriseName,
        enterprisePricing,
        id,
        isNetPricing,
        languageCode,
        propertyName,
        quantity,
        reservationGroupId,
        reservationGroupName,
        itemCategory,
    }: {
        amount: MultiCurrencyAmount;
        chainName: string | null;
        cityName: string;
        currencyCode: string;
        enterpriseName: string;
        enterprisePricing?: string;
        id: string;
        isNetPricing: boolean;
        languageCode: string;
        propertyName: LocalizedPropertyObject;
        quantity: number;
        reservationGroupId: string | null;
        reservationGroupName: string | null;
        itemCategory: 'Product' | 'Reservation';
    }
) => {
    const totalTax = pipe(
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        amount?.[currencyCode]?.taxValues || [],
        array.reduce(0, (acc, taxValue) => acc + taxValue.value)
    );

    return {
        item_id: id,
        item_name: localizeProperty(state, { property: propertyName, languageCode }),
        item_category: itemCategory,
        item_category2: enterpriseName,
        item_category3: cityName,
        item_brand: chainName,
        affiliation: enterpriseName,
        currency: amount?.[currencyCode].currency,
        price: isNetPricing ? amount?.[currencyCode]?.netValue : amount?.[currencyCode]?.grossValue,
        netPrice: amount?.[currencyCode]?.netValue,
        grossPrice: amount?.[currencyCode]?.grossValue,
        pricingMode: enterprisePricing,
        quantity,
        reservationGroupId,
        reservationGroupName,
        tax: totalTax,
    };
};
